import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '../types';
import { FeedbackState } from './types';

export const actions: ActionTree<FeedbackState, RootState> = {
}